module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 108);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=befe2302&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: _vm.transition },
      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave },
    },
    [
      _c(
        _vm.isPopover ? "kd-popover" : "div",
        _vm._b(
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPopover || _vm.visible,
                expression: "isPopover || visible",
              },
            ],
            tag: "component",
            class: [
              {
                "kdv-dialog__wrapper": !_vm.isPopover,
                "is-modeless": _vm.modeless,
              },
            ],
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.handleWrapperClick($event)
              },
            },
          },
          "component",
          _vm.popoverProps,
          false
        ),
        [
          _c("template", { slot: "reference" }, [_vm._t("reference")], 2),
          _c(
            "div",
            {
              key: _vm.key,
              ref: "dialog",
              class: [
                "kdv-dialog",
                _vm.customClass,
                _vm.size ? "kdv-dialog--" + _vm.size : "",
                {
                  "is-fullscreen": _vm.fullscreen,
                  "is-draggable": _vm.draggable,
                  "kdv-dialog--center": _vm.center,
                },
              ],
              style: _vm.style,
            },
            [
              _c(
                "div",
                { ref: "header", staticClass: "kdv-dialog__header" },
                [
                  _vm.showBack
                    ? _c(
                        "kd-button",
                        {
                          staticClass: "kdv-dialog__back",
                          attrs: { icon: "", size: "small" },
                          on: { click: _vm.onBtnBack },
                        },
                        [_c("kd-icon-arrow-left")],
                        1
                      )
                    : _vm._e(),
                  _vm.$slots.prefix
                    ? _c(
                        "span",
                        { staticClass: "kdv-dialog__prefix" },
                        [_vm._t("prefix")],
                        2
                      )
                    : _vm._e(),
                  _vm._t("title", [
                    _c("span", { staticClass: "kdv-dialog__title" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.title) + "\n          "
                      ),
                    ]),
                  ]),
                  _vm.$slots.suffix
                    ? _c(
                        "span",
                        { staticClass: "kdv-dialog__suffix" },
                        [_vm._t("suffix")],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    { staticClass: "kdv-dialog__actions" },
                    [_vm._t("actions")],
                    2
                  ),
                  _vm.showClose
                    ? _c(
                        "kd-button",
                        {
                          staticClass: "kdv-dialog__close",
                          attrs: { icon: "", size: "small" },
                          on: { click: _vm.onBtnClose },
                        },
                        [_c("kd-icon-close")],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm.subtitle
                ? _c("div", { staticClass: "kdv-dialog__subtitle" }, [
                    _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      "),
                  ])
                : _vm._e(),
              _vm.rendered
                ? _c(
                    "div",
                    { staticClass: "kdv-dialog__body" },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
              _vm.$slots.footer
                ? _c(
                    "div",
                    { staticClass: "kdv-dialog__footer" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=befe2302&

// EXTERNAL MODULE: external "@kdocs/kdesign-vue/lib/utils/popup"
var popup_ = __webpack_require__(17);
var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);

// EXTERNAL MODULE: external "@kdocs/kdesign-vue/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "@kdocs/kdesign-icons-vue/lib/icons/SymbolCrossTwo"
var SymbolCrossTwo_ = __webpack_require__(21);
var SymbolCrossTwo_default = /*#__PURE__*/__webpack_require__.n(SymbolCrossTwo_);

// EXTERNAL MODULE: external "@kdocs/kdesign-icons-vue/lib/icons/ArrowLeftL"
var ArrowLeftL_ = __webpack_require__(48);
var ArrowLeftL_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftL_);

// EXTERNAL MODULE: external "@kdocs/kdesign-vue/lib/button"
var button_ = __webpack_require__(11);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "@kdocs/kdesign-vue/lib/popover"
var popover_ = __webpack_require__(35);
var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);

// EXTERNAL MODULE: ./packages/color-picker/src/draggable.js
var draggable = __webpack_require__(31);

// EXTERNAL MODULE: external "@kdocs/kdesign-vue/lib/config"
var config_ = __webpack_require__(23);
var config_default = /*#__PURE__*/__webpack_require__.n(config_);

// EXTERNAL MODULE: external "@kdocs/kdesign-vue/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var componentvue_type_script_lang_js_ = ({
  name: 'KdDialog',

  mixins: [popup_default.a, emitter_default.a],
  components: {
    KdIconClose: SymbolCrossTwo_default.a,
    KdIconArrowLeft: ArrowLeftL_default.a,
    KdPopover: popover_default.a,
    KdButton: button_default.a
  },
  props: {
    title: {
      type: String,
      default: ''
    },

    subtitle: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: ''
    },

    modal: {
      type: Boolean,
      default: true
    },

    draggable: {
      type: Boolean,
      default: false
    },

    modalAppendToBody: {
      type: Boolean,
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: false
    },

    lockScroll: {
      type: Boolean,
      default: true
    },

    closeOnClickModal: {
      type: Boolean,
      default: true
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true
    },

    showClose: {
      type: Boolean,
      default: true
    },

    showBack: {
      type: Boolean,
      default: false
    },

    transition: {
      default: '', // dialog-fade
      type: String
    },

    // modalFade: {
    //   type: Boolean,
    //   default: false
    // },

    width: String,

    fullscreen: Boolean,

    customClass: {
      type: String,
      default: ''
    },
    beforeClose: Function,
    center: {
      type: Boolean,
      default: false
    },
    popoverOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    destroyOnClose: Boolean
  },

  data: function data() {
    return {
      closed: false,
      key: 0,
      rect: {},
      referenceElm: null,
      moveStyle: {},
      position: {
        startX: 0,
        startY: 0
      }
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        this.init();
        if (this.appendToBody) {
          config_default.a.getPopperContainer().appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener('scroll', this.updatePopper);
        if (this.draggable) {
          window.removeEventListener('resize', this.updatePosition);
        }
        if (!this.closed) this.$emit('close');
        if (this.destroyOnClose) {
          this.$nextTick(function () {
            _this.key++;
          });
        }
      }
    }
  },

  computed: {
    isPopover: function isPopover() {
      return this.referenceElm || this.$slots.reference;
    },
    popoverProps: function popoverProps() {
      if (this.isPopover) {
        var defaultOptions = {
          trigger: 'manual',
          placement: 'bottom-start',
          visibleArrow: false,
          popperClass: 'kdv-dialog__popover',
          reference: this.referenceElm
        };
        if (!this.popoverOptions || !this.popoverOptions.trigger) {
          defaultOptions.value = this.visible;
        }
        return merge_default()(defaultOptions, this.popoverOptions);
      }
      return {};
    },
    modeless: function modeless() {
      return !this.modal && !this.closeOnClickModal;
    },
    style: function style() {
      var style = {};
      if (!this.fullscreen) {
        if (this.width) {
          style.width = this.width;
        }
      }
      style = merge_default()({}, style, this.moveStyle);
      return style;
    }
  },

  methods: {
    handleWrapperClick: function handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose('modal');
    },
    onBtnClose: function onBtnClose() {
      this.handleClose('header');
    },
    onBtnBack: function onBtnBack() {
      this.handleClose('back');
    },
    handleClose: function handleClose(position) {
      var _this2 = this;

      if (typeof this.beforeClose === 'function') {
        this.beforeClose(function (cancel) {
          _this2.hide(cancel, position);
        });
      } else {
        this.hide(true, position);
      }
    },
    hide: function hide(cancel, position) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close', position);
        this.closed = true;
      }
    },
    updatePopper: function updatePopper() {
      this.broadcast('KdSelectDropdown', 'updatePopper');
    },
    afterEnter: function afterEnter() {
      this.$emit('opened');
    },
    afterLeave: function afterLeave() {
      this.$emit('closed');
    },
    handleDrag: function handleDrag(event, type) {
      var offsetLeft = event.x - this.position.startX;
      var offsetTop = event.y - this.position.startY;
      var left = this.rect.left + offsetLeft;
      var top = this.rect.top + offsetTop;

      if (type === 'end') {
        var position = this.getPosition(left, top, this.rect);
        left = position.left;
        top = position.top;
      }

      this.moveStyle = {
        position: 'fixed',
        left: left + 'px',
        top: top + 'px',
        margin: 0
      };
    },
    getPosition: function getPosition(left, top, rect) {
      left = Math.max(48, left);
      left = Math.min(left, document.body.clientWidth - rect.width - 48);
      top = Math.max(48, top);
      top = Math.min(top, document.body.clientHeight - rect.height - 48);
      return { left: left, top: top };
    },
    updatePosition: function updatePosition() {
      var el = this.$refs.dialog;
      var rect = el.getBoundingClientRect();
      var left = rect.left;
      var top = rect.top;
      var position = this.getPosition(left, top, rect);

      left = position.left;
      top = position.top;

      this.moveStyle = {
        position: 'fixed',
        left: left + 'px',
        top: top + 'px'
      };
    },
    init: function init() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.dialog.scrollTop = 0;
        _this3.moveStyle = {};

        if (_this3.draggable) {
          window.addEventListener('resize', _this3.updatePosition);
          Object(draggable["a" /* default */])(_this3.$refs.header, {
            start: function start(event) {
              var el = _this3.$refs.dialog;
              _this3.rect = el.getBoundingClientRect();
              _this3.position.startX = event.x;
              _this3.position.startY = event.y;
            },
            drag: function drag(event) {
              _this3.handleDrag(event, 'drag');
            },
            end: function end(event) {
              _this3.handleDrag(event, 'end');
            }
          });
        }
      });
    }
  },

  mounted: function mounted() {
    this.referenceElm = this.popoverOptions.reference || this.$refs.reference;

    // 基于元素定位的
    if (this.isPopover) {
      this.open = function () {};
    }

    if (this.visible) {
      this.rendered = true;
      this.open();
      this.init();
      if (this.appendToBody) {
        config_default.a.getPopperContainer().appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.draggable) {
      window.removeEventListener('resize', this.updatePosition);
    }
  }
});
// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/dialog/src/component.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_componentvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_component = (component.exports);
// EXTERNAL MODULE: ./packages/popover/src/directive.js
var directive = __webpack_require__(43);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(7);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./packages/dialog/index.js




external_vue_default.a.directive('dialog', directive["a" /* default */]);

/* istanbul ignore next */
src_component.install = function (Vue) {
  Vue.directive('dialog', directive["a" /* default */]);
  Vue.component(src_component.name, src_component);
};

/* harmony default export */ var dialog = __webpack_exports__["default"] = (src_component);

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-vue/lib/button");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-vue/lib/utils/popup");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-icons-vue/lib/icons/SymbolCrossTwo");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-vue/lib/config");

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

var isDragging = false;

/* harmony default export */ __webpack_exports__["a"] = (function (element, options) {
  if (vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$isServer) return;
  var moveFn = function moveFn(event) {
    if (options.drag) {
      options.drag(event);
    }
  };
  var upFn = function upFn(event) {
    document.removeEventListener('mousemove', moveFn);
    document.removeEventListener('mouseup', upFn);
    document.onselectstart = null;
    document.ondragstart = null;

    isDragging = false;

    if (options.end) {
      options.end(event);
    }
  };
  element.addEventListener('mousedown', function (event) {
    if (isDragging) return;
    document.onselectstart = function () {
      return false;
    };
    document.ondragstart = function () {
      return false;
    };

    document.addEventListener('mousemove', moveFn);
    document.addEventListener('mouseup', upFn);
    isDragging = true;

    if (options.start) {
      options.start(event);
    }
  });
});

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-vue/lib/popover");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-vue/lib/mixins/emitter");

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getReference = function getReference(el, binding, vnode) {
  var _ref = binding.expression ? binding.value : binding.arg;
  var popper = vnode.context.$refs[_ref];
  if (popper) {
    if (Array.isArray(popper)) {
      popper[0].$refs.reference = el;
    } else {
      popper.$refs.reference = el;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    getReference(el, binding, vnode);
  },
  inserted: function inserted(el, binding, vnode) {
    getReference(el, binding, vnode);
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-icons-vue/lib/icons/ArrowLeftL");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-vue/lib/utils/merge");

/***/ })

/******/ });